module.exports = __webpack_public_path__ + "img/qy_head.8146e029.png";